<template>
  <div class="trigger-element-wrapper" @click.stop="toggleChart">
    <slot></slot>
  </div>
</template>

<script setup>
const emit = defineEmits(['toggle']);

const toggleChart = () => {
  emit('toggle');
};
</script>

<style scoped>
.trigger-element-wrapper {
  cursor: pointer;
  width: 100%;
}
</style>
